module.exports = __webpack_public_path__ + "img/free.adba272d.png";